module.exports = __webpack_public_path__ + "static/media/inclusion_sum_insured.8f63552c.svg";